
import VDynamicGrid from '@/components/DynamicTable/VDynamicGrid.vue';
import VDynamicGridColumn from '@/components/DynamicTable/VDynamicGridColumn.vue';
import VFixedHierarchy from '@/components/DynamicTable/VFixedHierarchy.vue';
import VSpinner from '@/components/VSpinner.vue';
import { FixedColumns } from '@/ship/Models/DynamicTable';
import { Component, Prop, Ref, Vue } from 'vue-property-decorator';

@Component({
    components: { VDynamicGridColumn, VDynamicGrid, VSpinner, VFixedHierarchy },
})
export default class VDynamicTable extends Vue {
    @Prop({ type: Boolean, default: true })
    isTableView!: boolean;
    @Prop({ type: Boolean, default: false })
    isLoadingTable!: boolean;
    @Prop({ type: Object, default: () => ({ checkbox: '92px', code: '116px', name: '420px', functions: '82px' }) })
    fixedColumnWidths!: FixedColumns;
    @Prop({ type: Array, default: () => [] })
    versionsRows!: any[][];
    @Ref() refDynamicTable!: HTMLDivElement;

    hoveredRowId: number | null = null;
}
